
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Verification from "../pages/verification/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/verification",
    element: <Verification />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
